module.exports = __webpack_public_path__ + "img/10.d618a41d.png";